import React, { useContext } from 'react';
import { Dialog, DialogActions, DialogContent, Grow, makeStyles, Paper, Typography } from '@material-ui/core';
import { AppContext } from '../contexts/AppContext';
import { Bold } from './UI/TextFormatters';
import CircularCountdown from './UI/CircularCountdown';
import { redirectLogout, renewToken } from '../utils/RoutingUtils';
import { StopwatchTimerAnimated } from './UI/SVGAssets/SVGAssets';
import AnimatedButton from './UI/AnimatedButton';

const modalPaperStyles = makeStyles(theme => ({
  iconTab: {
    background: `radial-gradient(at bottom left, rgba(0,9,106,1) 0%, rgba(0,9,106,1) 100%)`,
    borderRadius: '30%',
    padding: '1.3em',
    top: -20,
    right: -20,
    width: 70,
    height: 70,
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transform: 'rotate(45deg)',
  },
  icon: {
    position: 'absolute',
    transform: 'rotate(-45deg)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 40,
    height: 40,
  },
  dialogPaper: {
    background: `radial-gradient(at bottom left,${theme.palette.primary.main} 0%, rgba(0,9,106,1) 80%)`,
  },
}));

const ModalPaper = ({ children }) => {
  const classes = modalPaperStyles();
  return (
    <div style={{ position: 'relative' }}>
      <div className={classes.iconTab}>
        <div className={classes.icon}>
          <StopwatchTimerAnimated
            fillTransition
            strokeTransition
            fill="rgba(255,255,255,.6)"
            stroke="rgba(255,255,255,.5)"
            strokeWidth={10}
          />
        </div>
      </div>
      <Paper className={classes.dialogPaper}>{children}</Paper>
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  backDrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    '@supports (backdrop-filter: blur(10px))': {
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      backdropFilter: 'blur(10px)',
    },
  },
}));

const InactivityModal = ({ open, setOpen, reset }) => {
  const classes = useStyles();
  const { showError } = useContext(AppContext);

  const handleContinue = () => {
    renewToken()
      .then(res => {
        setOpen(false);
        reset();
      })
      .catch(error => {
        showError(['No se pudo extender el tiempo de sesion.', 'Se requiere ingresar nuevamente.']);
        setTimeout(() => {
          redirectLogout();
        }, 2000);
      });
  };

  return (
    <Dialog
      TransitionComponent={Grow}
      disableBackdropClick
      transitionDuration={500}
      BackdropProps={{
        classes: {
          root: classes.backDrop,
        },
      }}
      PaperComponent={ModalPaper}
      maxWidth="sm"
      open={open}>
      <DialogContent>
        <div style={{ color: 'white' }}>
          <Typography variant="h6">
            <Bold>Sesión</Bold>
          </Typography>
          <div style={{ marginTop: '.2em' }}>
            Su sesión se encuentra próxima a vencerse por falta de actividad.<br></br>
            ¿Desea continuar utilizando la aplicación?
          </div>
          <div style={{ margin: '1.5em 0 1em 0' }}>
            <CircularCountdown
              matchFontSize
              size={80}
              colors={[
                ['#FFFFFF', 0.5],
                ['#FFFFFF', 0.4],
                ['#FF0000', 0.1],
              ]}
              duration={60}
              onComplete={redirectLogout}
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <AnimatedButton style={{ color: 'white' }} onClick={handleContinue}>
          Sí
        </AnimatedButton>
        <AnimatedButton style={{ color: 'white' }} onClick={redirectLogout}>
          No
        </AnimatedButton>
      </DialogActions>
    </Dialog>
  );
};
export default InactivityModal;
